import { request } from '../../../helpers/request';
import { Response } from '../../chat/slice/types';

const useGetTurncred = () => {
  const getTurnCred = async () => {
    try {
      const result: Response = await request(
        {
          method: 'GET',
          path: '/turn/credentials',
        },
        {},
        true,
      );
      if (result.success) {
        return result.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };
  return getTurnCred as () => Promise<Response>;
};
export default useGetTurncred;
